import {
  createPath,
  NavigateOptions,
  Path,
  To,
  useLocation,
  useNavigate as useRouterNavigate,
} from 'react-router'
import { INFLUENCER } from 'utils/constants/Helpers'

const useNavigate = () => {
  const location = useLocation()
  const navigate = useRouterNavigate()
  const isInfluencerFlow = location.pathname.includes(INFLUENCER)

  const customNavigate = (to: To | number, options?: NavigateOptions) => {
    const path = typeof to === 'string' ? to : createPath(to as Path)
    if (typeof to === 'number') {
      return navigate(to)
    }
    navigate(isInfluencerFlow ? `${INFLUENCER}${path}` : path, options)
  }

  return { navigate: customNavigate, isInfluencerFlow }
}

export default useNavigate
